import Axios from 'axios';
import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import ReactTable from 'react-table';

export const NewAttachment = (props) => {
  const [visible, setVisible] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const [submitting, setSubmitting] = React.useState(false);

  const fileColumns = [
    {
      Header: 'Filename',
      accessor: 'name',
    },
    {
      Header: '',
      maxWidth: 70,
      Cell: (rowdata) => {
        return (
          <a
            onClick={() => {
              files.splice(rowdata.index, 1);
              setFiles(files);
            }}
            href='#/'
            className='link text-info'>
            Delete
          </a>
        );
      },
    },
  ];

  const handleFileAdd = (event: any) => {
    setFiles([...files, event.target.files[0]]);
  };

  const handleClose = () => {
    setFiles([]);
    setVisible(false);
  };

  const onSubmit = async () => {
    setSubmitting(true);
    const formData = new FormData();
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }
    }
    try {
      await Axios.post(`${(window as any)._env_.REACT_APP_SERVER}/po/addAttachment`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        params: {
          poId: props.poId,
        },
      })
        .then((res) => {
          console.log('res: ', res?.status);
          alert('Files Uploaded Successfully');
          setSubmitting(false);
          handleClose();
          setTimeout(() => {
            window.location.reload();
          }, 600);
        })
        .catch((err) => {
          setSubmitting(false);
          // The server returns { errors: string[] } with a 400. Axios puts the
          // response body on err.response.data, not on err itself.
          const failedFiles: string[] = err?.response?.data?.errors ?? [];
          if (failedFiles.length > 0) {
            alert(`Error uploading files:\n${failedFiles.join('\n')}`);
          } else {
            alert('Error uploading files.');
          }
        });
    } catch (e) {
      alert(`Error Uploading Files: ${e}`);
      setSubmitting(false);
      handleClose();
    }
  };

  return (
    <div>
      <Button onClick={() => setVisible(true)} variant='danger'>
        Upload New Attachments&nbsp; {<i className='fa fa-upload' />}
      </Button>
      <Modal dialogClassName='modal-half-width' show={visible} onHide={() => setVisible(false)}>
        <Modal.Header>
          <Modal.Title>Upload New Attachments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id='form'>
            <div className='row justify-content-start m-1'>
              <div className='form-group'>
                <label>Attachments&nbsp;&nbsp;</label>
                <input type='file' name='attachments' onChange={(e) => handleFileAdd(e)} />
              </div>
            </div>
            {files.length !== 0 && (
              <div className='row justify-content-start mb-4'>
                <div className='col-sm'>
                  <ReactTable showPagination={false} columns={fileColumns} data={files} pageSize={files.length} NoDataComponent={() => null} />
                </div>
              </div>
            )}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='info' form='form' disabled={files.length < 1} onClick={() => onSubmit()}>
            {submitting && <Spinner className='mr-1' as='span' animation='border' size='sm' role='status' aria-hidden='true' />}
            Upload
          </Button>
          <Button onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
